import { Reveal } from "@/components/site/Reveal";
import { MANIFESTO } from "@/lib/site-data";

export const About = () => (
  <section id="about" className="relative mx-auto max-w-[1400px] px-6 py-28 lg:px-12 lg:py-40">
    <Reveal>
      <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-avatar-red">
        (About Avatar)
      </p>
      <h2 className="max-w-4xl font-heading text-3xl font-bold leading-tight tracking-tight text-avatar-ink md:text-5xl">
        Avatar Group crafts smart water tanks for modern homes — where durability
        meets purity, and design meets engineering.
      </h2>
    </Reveal>

    <div className="mt-24 space-y-2">
      {MANIFESTO.map((m, i) => (
        <Reveal key={m.n} delay={i * 0.08}>
          <div className="group grid grid-cols-1 items-start gap-6 border-t border-avatar-ink/10 py-12 md:grid-cols-[auto_1fr_1.4fr] md:gap-16">
            <span className="font-heading text-6xl font-bold leading-none text-avatar-ink/10 transition-colors duration-500 group-hover:text-avatar-red/40 md:text-8xl">
              {m.n}
            </span>
            <h3 className="font-heading text-3xl font-bold tracking-tight text-avatar-ink md:text-4xl">
              {m.title}
            </h3>
            <p className="max-w-xl text-base leading-relaxed text-avatar-ink/55 md:text-lg">
              {m.body}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
